import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'
import ProductList from '../views/Products.vue'
import ProductDetail from '../views/ProductDetail.vue'
import ShoppingCart from '../views/Cart.vue'
import CheckoutPage from '../views/Checkout.vue'
import LoginPage from '../views/Login.vue'
import RegisterPage from '../views/Register.vue'
import ProductCategories from '../views/Categories.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:company?',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/:company/productos',
    name: 'Products',
    component: ProductList
  },
  {
    path: '/:company/producto/:id',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/:company/categorias',
    name: 'Categories',
    component: ProductCategories
  },
  {
    path: '/:company/carrito',
    name: 'Cart',
    component: ShoppingCart
  },
  {
    path: '/:company/checkout',
    name: 'Checkout',
    component: CheckoutPage
  },
  {
    path: '/:company/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/:company/registro',
    name: 'Register',
    component: RegisterPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router